<template>
  <div>
    <el-select
      v-model="val"
      size="small"
      :class="{'require':getRequire && isNull(), 'item':true}"
      placeholder=" -- 请选择 -- "
      @change="change"
    >
      <el-option
        v-for="item in options"
        :key="item[keyField]"
        :label="item[valueField]"
        :value="item[keyField]"
      />
    </el-select>
    <el-tooltip v-if="errorSign" class="right" effect="dark" :content="message" placement="top">
      <div>
        <i class="el-icon-warning" style="color:red;line-height:32px;" />
      </div>
    </el-tooltip>
  </div>
</template>

<script>
import { verify } from '@/utils/ik/verify/verify.js'
export default {
  name: 'IkTableSelect',
  model: {
    // 属性
    prop: 'value',
    // 事件
    event: 'change'
  },
  props: {
    code: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    line: {
      type: Number,
      default: 0
    },
    value: {
      type: String,
      default: ''
    },
    edit: {
      type: Boolean,
      default: true
    },
    defaultValue: {
      type: String,
      default: ''
    },
    keyField: {
      type: String,
      default: ''
    },
    valueField: {
      type: String,
      default: ''
    },
    options: {
      type: Array,
      default: function() {
        return []
      }
    },
    require: {
      type: Boolean,
      default: false
    },
    rules: {
      type: Array,
      default: function() {
        return [
        ]
      }
    }
  },
  data() {
    return {
      val: '',
      errorSign: false,
      message: ''
    }
  },
  computed: {
    getRequire() {
      return this.require
    }
  },
  watch: {
    value: {
      handler(value, oldValue) {
        this.val = value
        if (this.val === '' || this.val === null || this.val === undefined) {
          for (const i of this.options) {
            if (i.key === this.defaultValue) {
              this.val = i.value
            }
          }
        }
        this.change(this.val)
      },
      immediate: true
    }
  },
  methods: {
    change(value) {
      // 取值验证
      this.message = verify(value, this.rules)
      if (this.message !== null) {
        this.errorSign = true
      } else {
        this.errorSign = false
      }
      // 空值验证
      if (this.isNull() && this.require) {
        this.errorSign = true
        this.message = "必填项，不可为空"
      }
      // v-model实现触发方法
      this.$emit('onFieldChange', this.line, this.code, '', value, this.errorSign, this.message)
      this.$emit('change', value)
    },
    isNull() {
      return this.val === '' || this.val === null || this.val === undefined
    },
    reset() {
      this.value = this.defaultValue
    },
    clean() {
      this.value = ''
    }
  }
}
</script>
<style scoped>
::v-deep.require> .el-input{
    border: red 1px solid;
}
.item{width:calc(100% - 30px)}
</style>
<style lang="scss" >
.el-form-item {
  margin-bottom: 12px;
  width: 100%;
}
.el-select {
  width: 100%;
}
.el-form-item__label {
  width: 180px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.el-form-item__content {
  width: calc(100% - 180px);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
